import React, { useContext } from "react"
import BlockWrapper from "@yumgmbh/gatsby-theme-yum-components/src/components/technical/BlockWrapper"
import BodyBlocks from "@yumgmbh/gatsby-theme-yum-components/src/components/technical/BodyBlocks"
import { AuthContext } from "../../context/AuthContext"

const ProtectionBlock = ({ block }) => {
  const { role } = useContext(AuthContext) || { role: ["none"] }

  const showInPreview = block?.show_in_preview

  if (
    typeof window !== "undefined" &&
    window.storyblok?.inEditor &&
    showInPreview
  ) {
    return <BlockPreview block={block} />
  }

  return (
    <>
      {typeof window !== "undefined" &&
        !window.storyblok?.inEditor &&
        (role?.includes(block.groups) ? (
          <BlockWrapper
            block={block}
            blockWidth="container"
            showHeadline="false"
            showButtons="false"
            blockDirection="vertical"
            className=""
          >
            <BodyBlocks body={block?.body} />
          </BlockWrapper>
        ) : null)}
    </>
  )
}

const BlockPreview = ({ block }) => {
  return (
    <BlockWrapper
      block={block}
      blockWidth="container"
      showHeadline="false"
      showButtons="false"
      blockDirection="vertical"
      className=""
    >
      <BodyBlocks body={block?.body} />
    </BlockWrapper>
  )
}

export default ProtectionBlock
